<template>
  <woot-modal
    :show="showAccountModal"
    :on-close="() => $emit('close-account-modal')"
  >
    <woot-modal-header
      :header-title="$t('SIDEBAR_ITEMS.CHANGE_ACCOUNTS')"
      :header-content="$t('SIDEBAR_ITEMS.SELECTOR_SUBTITLE')"
    />
    <div class="px-8 pt-4 pb-8">
      <div
        v-for="account in currentUser.accounts"
        :id="`account-${account.id}`"
        :key="account.id"
        class="pt-0 pb-0"
      >
        <button
          class="flex items-center justify-between w-full gap-3 px-4 py-3 border border-transparent rounded-lg outline-none cursor-pointer expanded clear link transition-colors duration-200 ease-out hover:bg-slate-25 hover:border-slate-100 focus-visible:ring-2 focus-visible:ring-accent-mint/70 dark:hover:bg-white/[0.05] dark:hover:border-white/[0.08]"
          @click="onChangeAccount(account.id)"
        >
          <span class="w-full min-w-0">
            <label :for="account.name" class="block text-start">
              <div
                class="text-base font-medium leading-5 truncate text-slate-800 dark:text-slate-100"
              >
                {{ account.name }}
              </div>
              <div class="mt-0.5 text-xs text-slate-500 dark:text-slate-300">
                {{ account.role }}
              </div>
            </label>
          </span>
          <fluent-icon
            v-show="account.id === accountId"
            class="flex-shrink-0 text-accent-mint"
            icon="checkmark-circle"
            type="solid"
            size="24"
          />
        </button>
      </div>
    </div>

    <div
      v-if="globalConfig.createNewAccountFromDashboard"
      class="modal-footer delete-item"
    >
      <button
        class="button success large expanded nice"
        @click="$emit('show-create-account-modal')"
      >
        {{ $t('CREATE_ACCOUNT.NEW_ACCOUNT') }}
      </button>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    showAccountModal: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      globalConfig: 'globalConfig/get',
    }),
  },
  methods: {
    onChangeAccount(accountId) {
      const accountUrl = `/app/accounts/${accountId}/dashboard`;
      window.location.href = accountUrl;
    },
  },
};
</script>
